// @ts-nocheck

export const noResponseInterceptor = (err) => {
  if (!err.response) {
    err.response = { statusText: err.message, status: -1 };
  }
  return Promise.reject(err);
};
